'use strict';
// #region dropdown
var dropdown = document.querySelector('.dropdown');
var trigger = dropdown.querySelector('.dropdown__trigger');
var languageListItems = document.querySelectorAll('.language-list__item');
trigger.addEventListener('click', function() {
    dropdown.classList.toggle('dropdown--active');
});
document.addEventListener('click', function(e) {
    if (!dropdown.contains(e.target)) dropdown.classList.remove('dropdown--active');
});
languageListItems.forEach(function(item) {
    item.addEventListener('click', function() {
        var selectedLanguage = item.textContent.trim();
        trigger.textContent = selectedLanguage;
        dropdown.classList.remove('dropdown--active');
    });
});
// #endregion
// #region aside menu
var body = document.querySelector('body');
var menu = document.querySelector('.page__menu');
var openMenuButton = document.querySelector('.icon--menu');
var closeMenuButton = document.querySelector('.icon--close');
var navLinks = menu.querySelectorAll('.nav__link');
function openMenu() {
    menu.classList.add('page__menu--open');
    body.classList.add('menu-lock');
}
function closeMenu() {
    menu.classList.remove('page__menu--open');
    body.classList.remove('menu-lock');
}
openMenuButton.addEventListener('click', openMenu);
closeMenuButton.addEventListener('click', function(e) {
    e.preventDefault();
    closeMenu();
});
navLinks.forEach(function(link) {
    link.addEventListener('click', closeMenu);
});
// #endregion
// #region menu items class change
function updateMenuTitleClass() {
    var menuLinks = document.querySelectorAll('.menu__nav .nav__link');
    menuLinks.forEach(function(menuLink) {
        if (window.innerWidth < 768) {
            menuLink.classList.remove('title--h3');
            menuLink.classList.add('title--h5');
        } else {
            menuLink.classList.remove('title--h5');
            menuLink.classList.add('title--h3');
        }
    });
}
updateMenuTitleClass();
window.addEventListener('resize', updateMenuTitleClass);
// #endregion
// #region form button
var form = document.getElementById('digestForm');
form.addEventListener('submit', function(e) {
    e.preventDefault();
    form.querySelector('input').value = '';
}); // #endregion

//# sourceMappingURL=Museum_2.da3e08b0.js.map
